/**
 * ajaxRequest configurations
 */
import axios from 'axios';
import store from '@/store';
import { apiUrlDictionary } from './api';
// import i18n from 'vue-i18n';

const instance = axios.create({
  baseURL: apiUrlDictionary,
  timeout: 100000000,
});

// Routing request interception
// http request Interceptor
instance.interceptors.request.use(
  config => {
    config.headers.common['Content-Type'] = 'application/json;charset=UTF-8';
    // Determine if there is a tiket. If it exists, then every HTTP header is added to tiket.
    if (store.getters['auth/isAutenticated']) {
      config.headers.common['Authorization'] = `Bearer ${store.getters['auth/accessToken']}`;
    }
    // if exists language settings
    // config.headers['Accept-Language'] = i18n.locale;
    config.headers['Accept-Language'] = store.getters['app/language'];
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);
// test
// Routing response interception
// http response Interceptor
instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 401) {
      // window.localStorage.removeItem('access_token')
      // if (window.location.hash !== '#/') {
      //   window.location.href = '/'
      // }
      // swal(
      //   'warning!',
      //   'Account has logged in on another device.',
      //   'warning'
      // )
      // swal({
      //   title: "warning",
      //   text: 'Account has logged in on another device.',
      //   icon: "warning",
      //   closeOnClickOutside: false,
      //   // buttons: true,
      //   // dangerMode: true,
      // })
      // .then((willDelete) => {
      //   if (willDelete) {
      //     window.localStorage.removeItem('access_token')
      //     if (window.location.hash !== '#/') {
      //       window.location.href = '/'
      //     }
      //   }
      // })
      // swal({
      //   title: 'warning!',
      //   text: "Account has logged in on another device.",
      //   type: 'warning',
      //   // showCancelButton: true,
      //   confirmButtonColor: '#3085d6',
      //   // cancelButtonColor: '#d33',
      //   confirmButtonText: 'Ok'
      // }).then((result) => {
      //   if (result.value) {
      //     // return the error code 401 to clear the tiket information and jump to the login page.
      //     window.localStorage.removeItem('access_token')
      //     if (window.location.hash !== '#/') {
      //       window.location.href = '/'
      //     }
      //   }
      // })
    }
    return Promise.reject(error);
  },
);
export default instance;
